var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPosition(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 20,
    viewBox: "0 0 22 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.75 6.75L3.75 3.75L0.75 0.75M0.75 6.75L6.75 0.75M14.75 0.75H19.75M19.75 0.75V5.75M19.75 0.75L2.75 17.75M20.75 15.75C20.75 17.4069 19.4069 18.75 17.75 18.75C16.0931 18.75 14.75 17.4069 14.75 15.75C14.75 14.0932 16.0931 12.75 17.75 12.75C19.4069 12.75 20.75 14.0932 20.75 15.75Z",
    stroke: "#121212",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPosition);
export default __webpack_public_path__ + "static/media/position.a940f0bc57bff9a27580e8721471f186.svg";
export { ForwardRef as ReactComponent };